import config from '../const'
import axios from 'axios'
export default {
  computed: {
    axiosHeader: function () {
      return { [config.BASE_API_HEADER_KEY]: this.$store.state.auth.token }
    },
    cHeader: function () {
      return { headers: this.axiosHeader }
    },
    axiosHeaderNonToken: function () {
      return { [config.BASE_API_USER_HEADER_KEY]: 'NON_LOGIN_ACCESS_TOKEN' }
    },
    nonloginHeader: function () {
      return { headers: this.axiosHeaderNonToken }
    }
  },
  methods: {
    async getConfigAPI(param) {
      const params = {}
      return await this.basicPosts_S(
        config.BASE_API_URL + '/config/' + param,
        params
      )
        .then(async response => {
          return response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          return []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async getConfigListsAPI(configs) {
      const params = {
        targets: configs
      }
      return await this.basicPosts_S(
        config.BASE_API_URL + '/configs/lists',
        params
      )
        .then(async response => {
          console.log('getConfigListsAPI response', response)
          return response.data && response.data.body
            ? response.data.body
            : false
        })
        .catch(async err => {
          console.log(err)
          return false
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    setParams(params, mode) {
      const params_ = new URLSearchParams()
      if (params) {
        const keys = Object.keys(params)
        for (let i = 0; i < keys.length; i++) {
          if (
            keys[i] == 'p'
            // || keys[i].indexOf('page') >= 0
          ) {
            params_.append(keys[i], params[keys[i]])
          } else if (
            params[keys[i]] !== null &&
            typeof params[keys[i]] === 'object'
          ) {
            params_.append(
              mode + '[' + keys[i] + ']',
              JSON.stringify(params[keys[i]])
            )
          } else {
            params_.append(mode + '[' + keys[i] + ']', params[keys[i]])
          }
        }
        if (mode == 'iprm' && keys.includes('manage_id') === false) {
          console.log(
            'manage_id insert',
            this.$store.state.auth.userId,
            params_
          )
          params_.append('iprm[manage_id]', this.$store.state.auth.userId)
        }
      }
      return params_
    },
    setParams_S(params) {
      return this.setParams(params, 'sprm')
    },
    setParams_I(params) {
      return this.setParams(params, 'iprm')
    },
    async basicGets_O(post_url) {
      const res = await this.basicGets(post_url, false)
      // console.log('globalActionsTest basicGets_O res', res)
      return res
    },
    async basicPosts_R(post_url, params) {
      const res = await this.basicPosts(post_url, params, true)
      // console.log('globalActionsTest basicPosts_R res', res)
      return res
    },
    async basicPosts_S(post_url, params) {
      const res = await this.basicPosts(
        post_url,
        this.setParams_S(params),
        true
      )
      // console.log('globalActionsTest basicPosts_S res', res)
      return res
    },
    async basicPosts_I(post_url, params) {
      // console.log('globalActionsTest basicPosts_I start')
      return await this.basicPosts(
        post_url,
        this.setParams_I(params),
        true
      ).finally(async () => {
        // console.log('globalActionsTest basicPosts_I finally')
        await this.scrollToAction()
      })
    },
    async basicPosts(post_url, params, inner) {
      return await axios
        .post(
          post_url,
          // this.setParams_S(params),
          params,
          inner ? this.cHeader : {}
        )
        .then(async response => {
          if (
            inner == true &&
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            parseInt(response.data.status) === 401
          ) {
            this.$router.push({ path: '/logout' })
          }
          // console.log('globalActionsTest basicPosts response', response)
          return response
        })
        .catch(async err => {
          // console.log('globalActionsTest basicPosts err', err)
          throw err
        })
        .finally(async () => {
          // console.log('globalActionsTest basicPosts finally')
          // return true;
        })
    },
    async basicGets(post_url, inner) {
      return await axios
        .get(
          post_url,
          // this.setParams_S(params),
          // params,
          inner ? this.cHeader : {}
        )
        .then(async response => {
          if (
            inner === true &&
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            parseInt(response.data.status) === 401
          ) {
            this.$router.push({ path: '/logout' })
          }
          // console.log('globalActionsTest basicPosts response', response)
          return response
        })
        .catch(async err => {
          // console.log('globalActionsTest basicPosts err', err)
          throw err
        })
        .finally(async () => {
          // console.log('globalActionsTest basicPosts finally')
          // return true;
        })
    },
    async nonloginPosts_S(post_url, params) {
      const res = await this.nonloginPosts(
        post_url,
        this.setParams_S(params),
        true
      )
      // console.log('globalActionsTest nonloginPosts_S res', res);
      return res
    },
    async nonloginPosts_I(post_url, params) {
      const res = await this.nonloginPosts(
        post_url,
        this.setParams_I(params),
        true
      )
      // console.log('globalActionsTest nonloginPosts_I res', res);
      return res
    },
    async nonloginPosts_R(post_url, params) {
      const res = await this.nonloginPosts(post_url, params, true)
      // console.log('globalActionsTest basicPosts_R res', res);
      return res
    },
    async nonloginPosts(post_url, params, inner) {
      return await axios
        .post(
          post_url,
          // this.setParams_S(params),
          params,
          inner ? this.nonloginHeader : {}
        )
        .then(async response => {
          if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            parseInt(response.data.status) === 401
          ) {
            // this.$router.push({ path: '/logout' });
          }
          // console.log('globalActionsTest nonloginPosts response', response);
          return response
        })
        .catch(async err => {
          // console.log('globalActionsTest nonloginPosts err', err);
          throw err
        })
        .finally(async () => {
          // console.log('globalActionsTest nonloginPosts finally');
          // return true;
        })
    },
    getRandomString(length) {
      const chars =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let string = ''
      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length)
        string += chars[randomIndex]
      }

      return string
    },
    async scrollToAction() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    async readAsTextReader(file) {
      const reader = new FileReader()
      return new Promise((resolve, reject) => {
        reader.onloadstart = ev => {
          console.log(`onloadstart: total=${ev.loaded}/${ev.loaded}`)
        }

        reader.onloadend = ev => {
          console.log(`onloadend: total=${ev.loaded}/${ev.loaded}`)
        }

        reader.onprogress = ev => {
          console.log(`onprogress: total=${ev.loaded}/${ev.loaded}`)
        }

        reader.onerror = () => {
          reader.abort()
          reject('Unknown error occurred during reading the file')
        }

        reader.onload = () => {
          console.log('onload')
          resolve(reader.result)
        }

        reader.readAsText(file)
      })
    }
  }
}
